module.exports = __webpack_public_path__ + "f1e6a071eba01a805e3d1ddd0dd06d6b.png";